import resolveImgUrl from "utils/resolveImgUrl";
import ItemPicker from "./ItemPicker";

type ItemListProps<T> = {
  items : (T)[],
  onDelete : (id : number) => void,
  onPick : (id : number) => void,
  maxLength : number,
  url : string,
}

const ItemList = <T extends {imgUrl : string, title : string, submittedBy : any, id:number},>({
  items, onDelete, onPick, maxLength = 4, url
}:ItemListProps<T>) =>{
  return <div className="grid grid-cols-4 gap-3 auto-rows-[8rem]">
    {items.map((e, i)=>{
        return (
          <div className="relative" key={e.id}>
            <img src={e ? resolveImgUrl(e.imgUrl) 
              : `https://via.placeholder.com/640x384.png?text=Banner`} 
              alt="" 
              className="w-full h-full object-cover"
            />

            <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 flex flex-col justify-center items-center">
              <div className="flex flex-col items-center text-center py-3">
                <div className="text-white text-sm">{e.title}</div>
                <div className="text-gray-300 text-sm">{e.submittedBy.name}</div>
              </div>
            </div>
            <div 
                className="z-[1] absolute top-2 right-2 grid place-content-center w-10 h-10 bg-white cursor-pointer opacity-60 hover:opacity-80 rounded-sm"
                onClick={()=>onDelete(e.id)}
            >
                <i className="fas fa-trash text-red-500"></i>
            </div>
          </div>
        )
    })}
    {
      items.length < maxLength && (
        <ItemPicker url={url} onSelect={(id)=>onPick(id)}>
          {(reference, referenceProp)=>
            <div ref={reference} {...referenceProp} className="relative">
              <div
                className="w-full h-full grid place-content-center group cursor-pointer border-2 rounded-md border-dashed border-gray-500 hover:border-blue-500"

              >
                <i className="fas fa-plus text-gray-500 group-hover:text-blue-500 text-4xl"></i>
              </div>
            </div>
          }
        </ItemPicker>
      )
    }
  </div>
}

export default ItemList;